export const generateUUID = () => {
    if (crypto.randomUUID) {
        return crypto.randomUUID();
    }
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    return [...array].map((b) => b.toString(16).padStart(2, '0')).join('');
};
